import React, { useContext, useEffect, useRef, useState } from "react";
import "./ProductComparison.scss";
import Title from "./Title";
import { Link } from "./Link";
import { HeaderContext } from "./HeaderVisibilityProvider";



function ProductComparison(props) {
  return (
    <section
      className="comparison position-relative"
      style={{
        paddingBottom: "10rem",
      }}
    >
      <div className="comparison_container">
        <Title title={"Выберите свой уровень автоматизации"}>
        </Title>
        <ComparisonTable
          features={props.features}
          products={props.products}
          // features={FEATURES}
          // products={PRODUCTS}
          active={props.active}
          changeActive={props.changeActive}
          links={props.links}
        />
      </div>
    </section>
  );
}

export const ComparisonTable = ({ active, changeActive, features, products, links }) => {
  const [fixedWidth, setFixedWidth] = useState(null);
  const tableRef = useRef();
  const headerContext = useContext(HeaderContext)
  useEffect(() => {
    const handleScroll = (e) => {
      if (!tableRef.current) {
        return
      }
      const tableRect = tableRef.current.getBoundingClientRect();
      const tableHeader = tableRef.current.querySelector('thead').getBoundingClientRect().height
      const headerHeight = getHeaderHeight()
      if (tableRect.top > headerHeight && fixedWidth != null) {
        setFixedWidth(null);
      }
      else if (tableRect.bottom < tableHeader + headerHeight && fixedWidth != null) {
        setFixedWidth(null);
      } else if (tableRect.top <= headerHeight && tableRect.bottom > tableHeader + headerHeight && fixedWidth == null) {
        setFixedWidth(tableRect.width);
      }
    };
    document
      .querySelector("#root .page-layout")?.addEventListener("scroll", handleScroll);
    return () =>
      document
        ?.querySelector("#root .page-layout")
        ?.removeEventListener("scroll", handleScroll);
  }, [fixedWidth, headerContext]);
  const getHeaderHeight = () => {
    if (!headerContext.visible) {
      return 0
    }
    const headerRect = document?.querySelector("header")?.getBoundingClientRect()
    if (!headerRect) {
      return
    }
    return headerRect.height
  }
  const renderValue = (v, idx) => {
    const isActive = idx == active;
    if (typeof v == "string") {
      return (
        <td
          style={{ background: isActive ? "rgba(41, 117, 219,30%)" : "" }}
          name={idx}
        >
          {v}
        </td>
      );
    }
    return (
      <td
        style={{ background: isActive ? "rgba(41, 117, 219,30%)" : "" }}
        name={idx}
      >
        {v == true ? <CheckIcon color={"green"} /> : v == false ? <RingIcon /> : <></>}
      </td>
    );
  };
  const renderLabel = (row) => {
    if (row.to) {
      return <Link to={row.to}>
        {row.label}
      </Link>
    }
    return row.label
  }
  const renderRow = (row) => {
    if (typeof row.items !== "undefined") {
      return (
        <GroupRow label={row.label} span={products.length + 1} link={row.link}>
          {row.items.map(renderRow)}
        </GroupRow>
      );
    } else {
      return (
        <tr>
          <td>
            <div style={{ fontWeight: "bold" }}>{renderLabel(row)}</div>
            <div>
              {row.description?.split("\n")?.map((str) => (
                <div className="mb-1">{str}</div>
              ))}
            </div>
          </td>
          {row.values.map(renderValue)}
        </tr>
      );
    }
  };
  const setVersion = (active) => {
    changeActive(active)
    // const plus = version = 'expert' ? 'false' : 'true'
    // const params = new URLSearchParams(location.search);
    // params.set('plus', plus);
    // navigate(`${location.pathname}?${params.toString()}`);
  }
  const renderHeader = () => {
    return (
      <thead>
        <tr>
          <th
            style={{
              width: "20rem",
              background: "rgb(242, 110, 89)",
              color: "white",
            }}
            className="p-3"
          >
            Функции
          </th>
          {products.map((p, idx) => {
            const isActive = idx == active;
            return (
              <th
                className="p-2"
                name={idx}
                style={{
                  background: isActive
                    ? "rgb(41 117 219)"
                    : "rgb(242, 110, 89)",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <div>{p}</div>
                <div>
                  {links?.[idx]?.type == "href" ? (
                    <a
                      href={links[idx].href}
                      target="_blank"
                      style={{
                        opacity: isActive ? 0 : 1,
                        pointerEvents: isActive ? "none" : "",
                      }}
                      className="btn btn-sm btn-primary mt-2"
                    >
                      Перейти
                    </a>
                  ) : (
                    <a
                      onClick={() => setVersion(idx)}
                      target="_blank"
                      style={{
                        opacity: isActive ? 0 : 1,
                        pointerEvents: isActive ? "none" : "",
                      }}
                      className="btn btn-sm btn-primary mt-2"
                    >
                      Перейти
                    </a>
                  )}
                </div>
              </th>
            );
          })}
        </tr>
      </thead>
    );
  };
  const renderFixedHeader = () => {
    if (fixedWidth == null) {
      return;
    }
    const height = getHeaderHeight()
    const tdList = tableRef.current.querySelectorAll('td')
    return (
      <table
        style={{
          position: "fixed",
          top: `${height}px`,
          width: `${fixedWidth}px`,
          overflow: "hidden",
          boxShadow: "0 10px 10px 2px rgba(0,0,0,0.3)",
        }}
        className="table table-striped mb-0   "
      >
        <thead>
          <tr>
            <th
              style={{
                width: `${tdList[0].offsetWidth}px`,
                background: "rgba(242, 110, 89,0.8)",
                color: "white",
                backdropFilter: "blur(3px)",
              }}
              className="p-3"
            >
              Функции
            </th>
            {products.map((p, idx) => {
              const tdWidth = tdList[idx + 1].offsetWidth
              console.log('width---', tdWidth)
              const isActive = idx == active;
              return (
                <th
                  className="p-2"
                  name={idx}
                  style={{
                    width: `${tdWidth}px`,
                    background: isActive
                      ? "rgba(41, 117, 219,0.8)"
                      : "rgba(242, 110, 89,0.8)",
                    color: "white",
                    textAlign: "center",
                    backdropFilter: "blur(3px)",
                  }}
                >
                  <div>{p}</div>
                  <div>
                    {links[idx].type == "href" ? (
                      <a
                        href={links[idx].href}
                        target="_blank"
                        style={{
                          opacity: isActive ? 0 : 1,
                          pointerEvents: isActive ? "none" : "",
                        }}
                        className="btn btn-sm btn-primary mt-2"
                      >
                        Перейти
                      </a>
                    ) : (
                      <a
                        onClick={() =>
                          setVersion(links[idx].version)
                        }
                        target="_blank"
                        style={{
                          opacity: isActive ? 0 : 1,
                          pointerEvents: isActive ? "none" : "",
                        }}
                        className="btn btn-sm btn-primary mt-2"
                      >
                        Перейти
                      </a>
                    )}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
      </table>
    );
  };
  return (
    <div
      style={{ borderRadius: "20px" }}
      className="  border   shadow bg-white w-100 overflow-hidden"
    >
      <table
        ref={tableRef}
        className="table table-striped mb-0 table-bordered comparison-table"
      >
        {renderHeader()}
        <tbody>
          {features.map(renderRow)}

          <tr>
            <td colSpan={products.length + 1}></td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={'100%'}>
              <div className="p-1" style={{ width: '100%' }} >
                <button onClick={() => window.open('/printcomparisontable', '_blank')} className="animated-gradient-btn  p-2 w-100">
                  Вывести на печать
                </button>
              </div>
            </td>

          </tr>

        </tfoot>
      </table>
      {renderFixedHeader()}
    </div>
  );
};

const GroupRow = ({ label, children, span, link }) => {
  const [expanded, setExpanded] = useState(true);
  return (
    <>
      <tr
        style={{ cursor: "pointer" }}
      // onClick={() => setExpanded(!expanded)}
      >
        <td
          colSpan={span}
          style={{
            textShadow: expanded ? "" : "0px 0px 3px black",
            letterSpacing: "1px",
            fontWeight: "bold",
            background:
              "linear-gradient(90deg, rgb(41, 117, 219) 0%, rgb(242, 110, 89) 97%)",

            // background: expanded ? 'rgb(41, 117, 219)' : '#23324730',
            color: "white",
          }}
        >
          <div
            className="d-flex w-100 align-items-center"
            style={{ gap: "10px" }}
          >
            {label}
            {link && (
              <a href={link.href}>
                <button type="button" className="animated-gradient-btn">
                  {link.title}
                </button>
              </a>
            )}
            {/* <div style={{ marginLeft: 'auto' }}><ChevronDownIcon style={{ transform: !expanded ? 'rotate(180deg)' : '' }} color={'white'} /></div> */}
          </div>
        </td>
      </tr>
      {expanded && children}
    </>
  );
};
const CheckIcon = ({ color, size }) => {
  const stroke = color || "#000000";
  return (
    <svg
      style={{
        boxShadow: '0px 0px 8px rgba(0,0,0,0.3)',
        borderRadius: '100%'
      }}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <rect width={24} height={24} fill="white" /> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L12.0243 14.3899C11.4586 14.9556 10.5414 14.9556 9.97568 14.3899L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929C8.68342 10.9024 9.31658 10.9024 9.70711 11.2929L11 12.5858L14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289Z"
        fill={stroke}
      />
    </svg>
  );
};
const CrossIcon = ({ color }) => {
  const stroke = color || "#000000";
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
        sketch:type="MSPage"
      >
        <g
          id="Icon-Set-Filled"
          transform="translate(-570.000000, -1089.000000)"
          fill={stroke}
        >
          <path
            d="M591.657,1109.24 C592.048,1109.63 592.048,1110.27 591.657,1110.66 C591.267,1111.05 590.633,1111.05 590.242,1110.66 L586.006,1106.42 L581.74,1110.69 C581.346,1111.08 580.708,1111.08 580.314,1110.69 C579.921,1110.29 579.921,1109.65 580.314,1109.26 L584.58,1104.99 L580.344,1100.76 C579.953,1100.37 579.953,1099.73 580.344,1099.34 C580.733,1098.95 581.367,1098.95 581.758,1099.34 L585.994,1103.58 L590.292,1099.28 C590.686,1098.89 591.323,1098.89 591.717,1099.28 C592.11,1099.68 592.11,1100.31 591.717,1100.71 L587.42,1105.01 L591.657,1109.24 L591.657,1109.24 Z M586,1089 C577.163,1089 570,1096.16 570,1105 C570,1113.84 577.163,1121 586,1121 C594.837,1121 602,1113.84 602,1105 C602,1096.16 594.837,1089 586,1089 L586,1089 Z"
            id="cross-circle"
          ></path>
        </g>
      </g>
    </svg>
  );
};
const ChevronDownIcon = ({ color, style }) => {
  const bgColor = color || "black";
  return (
    <svg
      style={style}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8.29289 10.2929C8.68342 9.90237 9.31658 9.90237 9.70711 10.2929L12 12.5858L14.2929 10.2929C14.6834 9.90237 15.3166 9.90237 15.7071 10.2929C16.0976 10.6834 16.0976 11.3166 15.7071 11.7071L13.1069 14.3073C12.4956 14.9186 11.5044 14.9186 10.8931 14.3073L8.29289 11.7071C7.90237 11.3166 7.90237 10.6834 8.29289 10.2929Z"
        fill={bgColor}
      />
    </svg>
  );
};
const RingIcon = ({ color }) => {
  const stroke = color || "black";
  return (
    <svg
      style={{
        boxShadow: '0px 0px 8px rgba(0,0,0,0.3)',
        borderRadius: '100%'
      }}
      fill={stroke}
      width="24px"
      height="24px"
      viewBox="-4 -4 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 16q0 3.264 1.28 6.208t3.392 5.12 5.12 3.424 6.208 1.248 6.208-1.248 5.12-3.424 3.392-5.12 1.28-6.208-1.28-6.208-3.392-5.12-5.088-3.392-6.24-1.28q-3.264 0-6.208 1.28t-5.12 3.392-3.392 5.12-1.28 6.208zM4 16q0-3.264 1.6-6.016t4.384-4.352 6.016-1.632 6.016 1.632 4.384 4.352 1.6 6.016-1.6 6.048-4.384 4.352-6.016 1.6-6.016-1.6-4.384-4.352-1.6-6.048z" />
    </svg>
  );
};



export default ProductComparison;
